export enum PauseDurationUnits {
    DAYS = "DAYS",
    WEEKS = "WEEKS",
    MONTHS = "MONTHS",
}

export interface AdvancedPauseDuration {
    duration: number
    durationUnits: PauseDurationUnits
}

export interface PauseStatus {
    pauseData: PauseData
    isPaused: boolean
}

export interface PauseSubmitResponse {
    pauseData: PauseData | undefined
}

export interface PauseSubmitRequest {
    info: string
    duration: number
    durationUnits: PauseDurationUnits
}

export enum PausePageStatus {
    LOADING_PAUSE_STATUS,
    PAUSE_STATUS_LOADED,
    SUBMITTING_INITIAL_PAUSE,
    UNPAUSE_SUCCESS,
    PAUSE_SUCCESS,
    PAUSE_STATUS_ERROR,
    PAUSE_STATUS_LOADED_SUBMIT_ERROR,
    INITIAL_PAUSE_ERROR,
    OPTION_PAUSE_ERROR,
}

export enum PauseSubmissionStatus {
    SUBMITTING,
    READY,
}

export interface PauseState {
    pauseStatus: PauseStatus
    pageStatus: PausePageStatus
    submissionStatus: PauseSubmissionStatus
}

export interface PauseData {
    startTimeSeconds: number
    endTimeSeconds: number
    duration: number
    durationUnits: PauseDurationUnits
}

export const defaultPauseData: PauseData = {
    startTimeSeconds: 0,
    endTimeSeconds: 0,
    duration: 0,
    durationUnits: PauseDurationUnits.MONTHS,
}

export const defaultPauseStatusResponse: PauseStatus = {
    pauseData: defaultPauseData,
    isPaused: false,
}

export const defaultPauseSubmitResponse: PauseSubmitResponse = {
    pauseData: defaultPauseData,
}

export type IPauseSubmitResponse = typeof defaultPauseSubmitResponse
export type IPauseStatusResponse = typeof defaultPauseStatusResponse
